import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import IdentificationFormPath from "../enums/IdentificationFormPath";
import IdentificationForm from "./IdentificationForm/IdentificationForm";
import Cancellation from "./Cancellation";
import PageLoader from "../components/PageLoader";

const CancellationRequest = lazy(() => import("./CancellationRequest"));
const NotFound = lazy(() => import("./NotFound"));
const CancellationChoice = lazy(() => import("./CancellationChoice"));
const ResendLastBookingConfirmation = lazy(
  () => import("./ResendLastBookingConfirmation")
);
const ScheduleChange = lazy(() => import("./ScheduleChange"));
const ScheduleChangeAlternative = lazy(
  () => import("./ScheduleChangeAlternative")
);
const VoucherRevoke = lazy(() => import("./VoucherRevoke"));
const NewsletterUnsubscribe = lazy(() => import("./NewsletterUnsubscribe"));

const Pages: React.FC = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path="/cancellation/:tripUuid">
          <Cancellation />
        </Route>
        <Route path="/cancellation-choice/:tripUuid/:bookingUuid">
          <CancellationChoice />
        </Route>
        <Route path="/cancellation-request/:tripUuid/:bookingUuid">
          <CancellationRequest />
        </Route>
        <Route path="/resend-last-booking-confirmation">
          <ResendLastBookingConfirmation />
        </Route>
        <Route path="/schedule-change-alternative">
          <ScheduleChangeAlternative />
        </Route>
        <Route path="/schedule-change-approved/:tripUuid/:bookingUuid">
          <ScheduleChange />
        </Route>
        <Route path="/voucher-revoke/:tripUuid">
          <VoucherRevoke />
        </Route>
        <Route path="/newsletter/:tripUuid/unsubscribe">
          <NewsletterUnsubscribe />
        </Route>
        <Route
          exact
          path={[
            IdentificationFormPath.IdentificationFormFillData,
            IdentificationFormPath.IdentificationFormCheckData,
            IdentificationFormPath.IdentificationFormConfirmation,
          ]}
          component={IdentificationForm}
        />
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Pages;
